import React, {useEffect, useState} from "react";
import {Col, Progress, Row, Table} from "reactstrap";
import moment from "moment/moment";
import {PaymentInterface} from "../../../../interfaces/private/PaymentInterface";

interface Props {
    open: number | boolean, // open > 0 show
    loading: boolean, // open > 0 show
    setOpen: Function,
    setLoading: Function,
    log: PaymentInterface,
}

const BodyModalPaymentDetailComponent: React.FC<Props> = ({log,loading,setLoading,setOpen, open, ...props}) => {
    return (
        <React.Fragment>
            <Row>
                <Table hover>
                    <tbody>
                    <tr><th scope="row">Pensopay Payment ID</th><td>{log.pensopay_payment_id}</td></tr>
                    <tr><th scope="row">Reference</th><td>{log.pensopay_payment_data?.order.reference}</td></tr>
                    <tr><th scope="row">Method</th><td>{log.pensopay_payment_data?.acquirer}</td></tr>
                    <tr><th scope="row">Amount</th><td>{log.pensopay_payment_data?.amount ? log.pensopay_payment_data.amount / 100 : 'n/a'}</td></tr>
                    <tr><th scope="row">Date</th><td>{moment(log.pensopay_payment_data?.created_at).format('hh:mm DD.MM.YY')}</td></tr>
                    <tr><th scope="row">Status</th><td>{log.df_status}</td></tr>
                    <tr><th scope="row">Message</th><td>{log.df_message}</td></tr>
                    <tr><th scope="row">Created at</th><td>{moment(log.pensopay_payment_data?.created_at).format('hh:mm DD.MM.YY')}</td></tr>
                    <tr>
                        <th scope="row">
                            Data
                        </th>
                        <td>
                            <pre>{JSON.stringify(log.pensopay_payment_data,null,2)}</pre>
                        </td>
                    </tr>

                    </tbody>
                </Table>
            </Row>

            {/*<Row>
                <Col>
                    <div className={'d-flex justify-content-end gap-2'}>
                        <QButton
                            type={'default'}
                            onClick={() => {
                                setOpen(false)
                            }}
                            content={t("common.button.cancel")}
                        />

                        <QButton
                            type={'primary'}
                            onClick={handleSubmit}
                            content={t("common.button.submit")}
                        />

                    </div>
                </Col>
            </Row>*/}
        </React.Fragment>
    )
}

export default BodyModalPaymentDetailComponent
